export default [
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  120,
  119,
  118,
  118,
  117,
  117,
  116,
  115,
  115,
  114,
  114,
  114,
  113,
  112,
  111,
  111,
  110,
  109,
  109,
  108,
  108,
  107,
  107,
  106,
  105,
  104,
  103,
  103,
  102,
  101,
  100,
  100,
  99,
  98,
  97,
  96,
  95,
  95,
  94,
  93,
  92,
  92,
  91,
  90,
  89,
  88,
  87,
  86,
  86,
  85,
  84,
  83,
  82,
  81,
  80,
  79,
  78,
  77,
  76,
  75,
  74,
  72,
  70,
  68,
  67,
  66,
  64,
  62,
  61,
  56,
  52,
  41,
  37,
];
